export const REQUIRED_FIELD = "Please, fill in the marked fields";

export const SERVICE_TYPES = {
  PIForm: 1,
  creditInfoForm: 2,
  ContactInfoChangeForm: 3,
  ibRegistration: 4,
  IBservicechange: 5,
  KYCform: 6,
  Legal: 7,
  identification: 8,
  taxInfo: 9,
  loanApplication: 10,
  piOnboarding: 11,
};
